'use strict';

var _extends = require('@babel/runtime/helpers/extends');
var _slicedToArray = require('@babel/runtime/helpers/slicedToArray');
require('@cochlear-design-system/foundation/dist/index.css');
require('@cochlear-design-system/features.adaptiveForms/dist/index.css');
var foundation = require('@cochlear-design-system/foundation');
var sitecoreJssReactForms = require('@sitecore-jss/sitecore-jss-react-forms');
var React = require('react');
var _objectWithoutProperties = require('@babel/runtime/helpers/objectWithoutProperties');
var _defineProperty = require('@babel/runtime/helpers/defineProperty');
var _toConsumableArray = require('@babel/runtime/helpers/toConsumableArray');
var _typeof = require('@babel/runtime/helpers/typeof');
var _classCallCheck = require('@babel/runtime/helpers/classCallCheck');
var _createClass = require('@babel/runtime/helpers/createClass');
var sitecoreJssForms = require('@sitecore-jss/sitecore-jss-forms');
var _asyncToGenerator = require('@babel/runtime/helpers/asyncToGenerator');
var _regeneratorRuntime = require('@babel/runtime/regenerator');
var axios = require('axios');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var _slicedToArray__default = /*#__PURE__*/_interopDefaultLegacy(_slicedToArray);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var _objectWithoutProperties__default = /*#__PURE__*/_interopDefaultLegacy(_objectWithoutProperties);
var _defineProperty__default = /*#__PURE__*/_interopDefaultLegacy(_defineProperty);
var _toConsumableArray__default = /*#__PURE__*/_interopDefaultLegacy(_toConsumableArray);
var _typeof__default = /*#__PURE__*/_interopDefaultLegacy(_typeof);
var _classCallCheck__default = /*#__PURE__*/_interopDefaultLegacy(_classCallCheck);
var _createClass__default = /*#__PURE__*/_interopDefaultLegacy(_createClass);
var _asyncToGenerator__default = /*#__PURE__*/_interopDefaultLegacy(_asyncToGenerator);
var _regeneratorRuntime__default = /*#__PURE__*/_interopDefaultLegacy(_regeneratorRuntime);
var axios__default = /*#__PURE__*/_interopDefaultLegacy(axios);

var _excluded = ["labelComponent"];
var baseLabelClass = 'ccl__form-input__label ccl__text ccl__text--body-text-bold';

var Label = function Label(props) {
  if (props.labelComponent) {
    var CustomLabel = props.labelComponent; // strip the label component from the custom component props
    // (prevents infinite loop rendering if someone reuses this component as a custom label component)

    props.labelComponent;
        var labelComponentProps = _objectWithoutProperties__default["default"](props, _excluded);

    return /*#__PURE__*/React__default["default"].createElement(CustomLabel, labelComponentProps);
  }

  var field = props.field,
      children = props.children;
  var className = "".concat(baseLabelClass, " ").concat(field.model.labelCssClass);

  if (!field.model.title) {
    return /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, children);
  }

  return /*#__PURE__*/React__default["default"].createElement("label", {
    htmlFor: field.valueField.id,
    className: className,
    key: field.valueField.id
  }, field.model.title, children);
};

function ownKeys$3(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$3(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$3(Object(source), !0).forEach(function (key) { _defineProperty__default["default"](target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$3(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var reducer = function reducer(state, action) {
  var type = action.type,
      fieldKey = action.fieldKey,
      value = action.value;

  switch (type) {
    case 'update_field_values':
      return _objectSpread$3(_objectSpread$3({}, state), {}, {
        fieldValues: _objectSpread$3(_objectSpread$3({}, state.fieldValues), {}, _defineProperty__default["default"]({}, fieldKey, value))
      });

    case 'update_field_state':
      return _objectSpread$3(_objectSpread$3({}, state), {}, {
        fieldState: _objectSpread$3(_objectSpread$3({}, state.fieldState), {}, _defineProperty__default["default"]({}, fieldKey, value))
      });

    default:
      return state;
  }
};

var initialState = {
  conditions: {},
  conditionFields: [],
  fieldValues: {}
};
var FormContext = /*#__PURE__*/React__default["default"].createContext({
  state: initialState,
  dispatch: function dispatch() {
    return null;
  }
});
var FormProvider = function FormProvider(_ref) {
  var children = _ref.children,
      initialState = _ref.initialState;

  var _React$useReducer = React__default["default"].useReducer(reducer, initialState),
      _React$useReducer2 = _slicedToArray__default["default"](_React$useReducer, 2),
      state = _React$useReducer2[0],
      dispatch = _React$useReducer2[1];

  return /*#__PURE__*/React__default["default"].createElement(FormContext.Provider, {
    value: [state, dispatch]
  }, children);
};

var ACTIONS = {
  // related to conditions
  SHOW: '{AAE07A52-46A4-49EF-98B0-C2595BAC2382}',
  HIDE: '{7F58C8DD-D7C0-4FB7-BB44-8EC6B5E1C3D9}',
  ENABLE: '{5744A87E-E32C-42CC-862F-96842A0202BB}',
  DISABLE: '{C698C993-549E-486A-A09C-BB8D830DA958}',
  // submit button-specific actions
  GO_TO_PAGE: '{4E448D57-BA06-42DC-9519-6BCD102CB332}',
  SAVE_DATA: '{0C61EAB3-A61E-47B8-AE0B-B6EBA0D6EB1B}',
  // form submit actions
  REDIRECT_TO_PAGE: '{3F3E2093-9DEA-4199-86CA-44FC69EF624D}',
  SUBMIT_TO_MARKETO: '{975806D4-C61B-4FEF-A870-AC0670258943}',
  SUBMIT_DOWNLOAD_GATED_ASSET_TO_MARKETO: '{0D2B2FAA-D8BF-4B9C-A375-7A435C9158D2}',
  SUBMIT_TO_SF: '{1CC467CA-4512-4C16-B945-CCC10C2BB1AC}'
};
var CONDITIONS = {
  IS_EQUAL_TO: '{1D38B217-A2EE-4E7B-B6ED-13E751462FEB}',
  IS_NOT_EQUAL_TO: '{49F47E77-E8C5-46F9-BF39-78D6B0D40B48}',
  CONTAINS: '{BF8935A6-1976-43A0-ABA5-D0BC128A76EA}',
  DOES_NOT_CONTAIN: '{45AAB0FB-775B-40F5-B3B8-7CAE3ABBF643}',
  STARTS_WITH: '{FD10F291-3C2E-4AE7-8A67-2F8271CB3DF2}',
  DOES_NOT_START_WITH: '{6B92597D-F2E0-47D3-A40D-59AFB37EEDE5}',
  ENDS_WITH: '{D375ED5B-E156-4A2B-9F91-DFD5B03F0D78}',
  DOES_NOT_END_WITH: '{F3AC7A1A-3458-4385-BB65-860315313DB3}',
  IS_GREATER_THAN: '{61FF63A0-375C-47BD-9986-1F81BD12BBBB}',
  IS_GREATER_THAN_OR_EQUAL_TO: '{062C6ED9-EA6E-4A88-AE54-C88E2147971D}',
  IS_LESS_THAN: '{8FE41E53-AD87-4D24-B50F-EA0F6BDF739F}',
  IS_LESS_THAN_OR_EQUAL_TO: '{88AC1C6B-BAFE-40A7-BB75-E304C8EC29DD}'
};
var MATCH_TYPES = {
  ANY: '{365C94DA-C1CD-4783-A91D-0D17A16C7117}',
  ALL: '{4E50C172-7EA6-4989-82C3-75F24F80EF72}'
};
var VALIDATORS = {
  REQUIRED: '{26ED106E-1DA1-4F18-844A-EEF1439BB30D}'
};
var DELIMITERS = {
  CHECKBOX_LIST: ';'
};

/**
 * @param {ValueFormField} field
 * @param {string | string[] } fieldValue
 * @param {props} props
 * @param {function} onChange
 * @param {function} dispatch
 * @param {object} state
 */

function handleOnChange(field, fieldValue, onChange, dispatch, state) {
  var forceValidate = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;
  // onChange expects array from fieldValue
  // validation & conditions state expects single value
  // take first value of value array as value in this case
  // since we don't support array-like fields such as checkbox-list
  var value = Array.isArray(fieldValue) ? fieldValue[0] : fieldValue;

  var _checkFieldValidity = checkFieldValidity(field, value),
      valid = _checkFieldValidity.valid,
      errorMessages = _checkFieldValidity.errorMessages; // here we pass value which will always be a string
  // update values in form context


  dispatch({
    type: 'update_field_values',
    fieldKey: field.model.conditionSettings.fieldKey,
    value: value
  }); // check and update validations if field currently has errors
  // allow user to correct errors, but don't raise new ones until blur

  if (forceValidate || state.fieldState && state.fieldState[field.valueField.name] && state.fieldState[field.valueField.name].length > 0) {
    validateCustomLabels(field.model.labelCssClass, valid); // here we pass fieldValue which may be string or string array

    onChange(field.valueField.name, fieldValue, valid, errorMessages);
    dispatch({
      type: 'update_field_state',
      fieldKey: field.valueField.name,
      value: errorMessages
    });
  } else {
    // track value but don't validate
    onChange(field.valueField.name, fieldValue, true, []);
  }
}

var sendToDataLayer = function sendToDataLayer(obj) {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(obj);
};
var getFormNameFromLocation = function getFormNameFromLocation() {
  var formNameIdx = window.location.pathname.lastIndexOf('/');
  return window.location.pathname.substring(formNameIdx + 1);
};
var sendFormInteraction = function sendFormInteraction(fieldName) {
  sendToDataLayer({
    event: 'form interaction',
    'form title': getFormNameFromLocation(),
    'form field': fieldName
  });
};
var sendFormSubmitSuccess = function sendFormSubmitSuccess() {
  sendToDataLayer({
    event: 'form submit',
    'form title': getFormNameFromLocation()
  });
};
var sendFormSubmitValidationError = function sendFormSubmitValidationError() {
  var validationResult = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  sendToDataLayer({
    event: 'form submit error',
    'form title': getFormNameFromLocation(),
    'form field': validationResult.toString()
  });
};

/**
 * Format country from sitecore siteObject to standard ISO format for Geonames
 * @param {string} originalCountry
 */
var formatCountry = function formatCountry(originalCountry) {
  // return default empty for non-standard regions
  if (originalCountry.length !== 2) {
    return '';
  } // sitecore-specific regions


  switch (originalCountry) {
    // latin america - Argentina
    case 'la':
      return 'AR';
    // middle east - no default

    case 'me':
      return '';
    // non-standard Sweden

    case 'sv':
      return 'SE';
    // non-standard UK

    case 'uk':
      return 'GB';

    default:
      return originalCountry.toUpperCase();
  }
};

/**
 * Format language from sitecore siteObject to standard format for Geonames
 * @param {string} originalLanguage
 */
var formatLanguage = function formatLanguage(originalLanguage) {
  // accommodate country-specific languages e.g. 'it-IT'
  return originalLanguage.slice(0, 2);
};

var validate = function validate(operator, value, valueAgainst) {
  var _operators;

  var operators = (_operators = {}, _defineProperty__default["default"](_operators, CONDITIONS["CONTAINS"], function () {
    var regex = RegExp("".concat(valueAgainst));
    return regex.test(value);
  }), _defineProperty__default["default"](_operators, CONDITIONS["DOES_NOT_CONTAIN"], function () {
    var regex = RegExp("^((?!".concat(valueAgainst, ").)*$"));
    return regex.test(value);
  }), _defineProperty__default["default"](_operators, CONDITIONS["STARTS_WITH"], function () {
    var regex = RegExp("^".concat(valueAgainst));
    return regex.test(value);
  }), _defineProperty__default["default"](_operators, CONDITIONS["DOES_NOT_START_WITH"], function () {
    var regex = RegExp("^(?!".concat(valueAgainst, ").*$"));
    return regex.test(value);
  }), _defineProperty__default["default"](_operators, CONDITIONS["ENDS_WITH"], function () {
    var regex = RegExp("".concat(valueAgainst, "$"));
    return regex.test(value);
  }), _defineProperty__default["default"](_operators, CONDITIONS["DOES_NOT_END_WITH"], function () {
    var regex = RegExp("^(.(?!".concat(valueAgainst, "$))+$"));

    if (value === '') {
      // regex fails to test an empty string
      return true;
    }

    return regex.test(value);
  }), _defineProperty__default["default"](_operators, CONDITIONS["IS_EQUAL_TO"], function () {
    var compareAgainst = valueAgainst === 'true' ? true : valueAgainst; // for empty fields we need to compare against empty string

    if (value === null || value === undefined) {
      return '' === compareAgainst;
    }

    return value === compareAgainst;
  }), _defineProperty__default["default"](_operators, CONDITIONS["IS_NOT_EQUAL_TO"], function () {
    return value !== valueAgainst;
  }), _defineProperty__default["default"](_operators, CONDITIONS["IS_GREATER_THAN"], function () {
    return value > valueAgainst;
  }), _defineProperty__default["default"](_operators, CONDITIONS["IS_GREATER_THAN_OR_EQUAL_TO"], function () {
    return value >= valueAgainst;
  }), _defineProperty__default["default"](_operators, CONDITIONS["IS_LESS_THAN"], function () {
    return value < valueAgainst;
  }), _defineProperty__default["default"](_operators, CONDITIONS["IS_LESS_THAN_OR_EQUAL_TO"], function () {
    return value <= valueAgainst;
  }), _operators);

  if (typeof operators[operator] === 'undefined') {
    return false;
  }

  return operators[operator]();
};

var handleActionType = function handleActionType(actionType, value) {
  var _actions;

  var actions = (_actions = {}, _defineProperty__default["default"](_actions, ACTIONS["SHOW"], function () {
    return !value;
  }), _defineProperty__default["default"](_actions, ACTIONS["HIDE"], function () {
    return value;
  }), _defineProperty__default["default"](_actions, ACTIONS["ENABLE"], function () {
    return !value;
  }), _defineProperty__default["default"](_actions, ACTIONS["DISABLE"], function () {
    return value;
  }), _actions);
  return actions[actionType]();
};

var matchingTypes = function matchingTypes(fieldValues, item) {
  var _matches;

  var matches = (_matches = {}, _defineProperty__default["default"](_matches, MATCH_TYPES['ANY'], function (fieldValues, item) {
    return item.conditions.some(function (condition) {
      var value = fieldValues[condition.fieldId],
          operator = condition.operatorId,
          valueAgainst = condition.value;
      return validate(operator, value, valueAgainst);
    });
  }), _defineProperty__default["default"](_matches, MATCH_TYPES['ALL'], function (fieldValues, item) {
    if (!item.conditions.length) {
      return false;
    }

    return item.conditions.every(function (condition) {
      var value = fieldValues[condition.fieldId],
          operator = condition.operatorId,
          valueAgainst = condition.value;
      return validate(operator, value, valueAgainst);
    });
  }), _matches);
  var result = matches[item.matchTypeId](fieldValues, item);
  return handleActionType(item.actionTypeId, result);
};

var checkConditions = function checkConditions(fieldValues, conditions) {
  var shouldHide;

  if (conditions) {
    for (var i = 0; i < conditions.length; i += 1) {
      shouldHide = matchingTypes(fieldValues, conditions[i]);

      if (shouldHide) {
        break;
      }
    }
  }

  return shouldHide;
};

var useVisibility = function useVisibility(onChange, field, value) {
  var _useContext = React.useContext(FormContext),
      _useContext2 = _slicedToArray__default["default"](_useContext, 2),
      state = _useContext2[0],
      dispatch = _useContext2[1];

  var _useState = React.useState(false),
      _useState2 = _slicedToArray__default["default"](_useState, 2),
      hidden = _useState2[0],
      setVisibility = _useState2[1];

  React.useEffect(function () {
    var _checkConditions = checkConditions(state.fieldValues, state.conditions[field.model.conditionSettings.fieldKey]);

    if (_checkConditions) {
      // save value but reset validation checks
      if (typeof onChange === 'function') {
        onChange(field.valueField.name, value, true, []);
        dispatch({
          type: 'update_field_state',
          fieldKey: field.valueField.name,
          value: []
        });
      }

      setVisibility(true);
    } else if (_checkConditions === false) {
      setVisibility(false);
    }
  }, [state.fieldValues]);
  return hidden;
};

//checks if errors exist in field state OR if errors exist in submission state
var checkValidations = function checkValidations(errors, fieldState, fieldKey) {
  // if model has no value field this is a label or plain text - we don't validate
  if (!fieldKey.valueField) {
    return errors;
  }

  var _fieldKey = fieldKey.valueField.name; // if errors exist we display field errors

  if (errors.length > 0) {
    return errors;
  } // if no errors we want to check if errors exist in the submission state 


  if (fieldState && fieldState[_fieldKey]) {
    return fieldState[_fieldKey];
  } // else we return errors unmodified


  return errors;
};

var PhoneWithCountryCodeEntry = /*#__PURE__*/function () {
  function PhoneWithCountryCodeEntry(country, callingCode, number) {
    _classCallCheck__default["default"](this, PhoneWithCountryCodeEntry);

    this.country = country;
    this.callingCode = callingCode;
    this.number = number;
  }

  _createClass__default["default"](PhoneWithCountryCodeEntry, [{
    key: "toString",
    value: function toString() {
      return !this.callingCode || !this.number ? '' : "+".concat(this.callingCode).concat(this.number);
    }
  }]);

  return PhoneWithCountryCodeEntry;
}();

var PhoneWithCountryCode = function PhoneWithCountryCode(props) {
  var _useContext = React.useContext(FormContext),
      _useContext2 = _slicedToArray__default["default"](_useContext, 2),
      state = _useContext2[0],
      dispatch = _useContext2[1]; // form context to track validating the completed value
  // value is either '' or entire valid string with '+'


  var field = props.field,
      errors = props.errors,
      value = props.value,
      onChange = props.onChange,
      siteObject = props.siteObject;
  var initialCountry = formatCountry(siteObject.country); // internal state to track field values

  var _useState = React.useState(initialCountry),
      _useState2 = _slicedToArray__default["default"](_useState, 2),
      countryValue = _useState2[0],
      setCountryValue = _useState2[1];

  var _useState3 = React.useState(''),
      _useState4 = _slicedToArray__default["default"](_useState3, 2),
      inputValue = _useState4[0],
      setInputValue = _useState4[1];

  var hidden = useVisibility(onChange, field, value);

  if (hidden) {
    return null;
  }

  var errorArray = checkValidations(errors, state.fieldState, field);
  var showError = errorArray && errorArray.length > 0;

  var handleChange = function handleChange(_, _ref) {
    var country = _ref.country,
        callingCode = _ref.callingCode,
        number = _ref.number;
    var newCallingCode = callingCode.replace(' ', '');
    setCountryValue(country);
    setInputValue(number);

    if (country && number) {
      handleOnChange(field, new PhoneWithCountryCodeEntry(country, newCallingCode, number), onChange, dispatch, state);
    } else {
      // report as invalid field if either country or number hasn't been selected
      handleOnChange(field, new PhoneWithCountryCodeEntry(), onChange, dispatch, state);
    }
  };

  var handleBlur = function handleBlur(evtOrName) {
    // push invalid state if country was blurred without selecting
    var blurredCountryEmpty = typeof evtOrName === 'string' && !countryValue; // always push validity state after blurring input field

    var blurredInput = _typeof__default["default"](evtOrName) === 'object';

    if (blurredCountryEmpty || blurredInput) {
      handleOnBlur(field, props, dispatch);
    }
  };

  return /*#__PURE__*/React__default["default"].createElement("div", {
    className: "ccl__edit-mode__element"
  }, /*#__PURE__*/React__default["default"].createElement(foundation.PhoneInput, {
    country: initialCountry,
    error: showError,
    errorMsg: showError ? errorArray[0] : undefined,
    hint: field.model.phoneInputLabel,
    hintForCode: field.model.countryCodeLabel,
    id: field.valueField.id,
    label: field.model.title,
    lng: formatLanguage(siteObject.lang),
    name: field.model.name,
    noOptionsMessage: field.model.noMatchesMessage,
    onBlur: handleBlur,
    onChange: handleChange,
    onFieldFocus: function onFieldFocus() {
      return sendFormInteraction(field.model.title);
    },
    promptText: field.model.placeholderText,
    promptTextForCode: field.model.countryCodePlaceholderText,
    value: inputValue
  }));
};

function validateDataModels(validator, fieldValue) {
  if (!validator.parameters) {
    return {
      valid: true
    };
  }

  var validatorParams = JSON.parse(validator.parameters);

  if ('regularExpression' in validatorParams) {
    var regex;

    if (validatorParams.type === 'region') {
      var _$exec;

      var region = (_$exec = /([A-z]{2})\/([A-z]{2})\/*/.exec(window.location.pathname)) === null || _$exec === void 0 ? void 0 : _$exec[1];
      regex = new RegExp(validatorParams.regularExpression[region]);
    } else {
      regex = new RegExp(validatorParams.regularExpression);
    } // whether field should be regarded as valid or invalid if the regex matches


    if (!!validatorParams.invalidOnMatch === regex.test(fieldValue)) {
      return {
        valid: false,
        errorMessage: validator.message
      };
    }
  } else if ('minimumAge' in validatorParams) {
    var minimumAge = validatorParams.minimumAge;
    var now = new Date();
    var dateToday = now.getDate(); // getMonth returns zero-indexed month

    var monthToday = now.getMonth() + 1;
    var yearToday = now.getFullYear();

    var _fieldValue$split$map = fieldValue.split('-').map(Number),
        _fieldValue$split$map2 = _slicedToArray__default["default"](_fieldValue$split$map, 3),
        year = _fieldValue$split$map2[0],
        month = _fieldValue$split$map2[1],
        day = _fieldValue$split$map2[2];

    var isMinimumAge = // previous year
    year + minimumAge < yearToday || // same year, previous month
    year + minimumAge === yearToday && (month < monthToday || // same year and month, previous day or today
    month === monthToday && day <= dateToday);

    if (!isMinimumAge) {
      return {
        valid: false,
        errorMessage: validator.message.replace('{0}', minimumAge)
      };
    }
  } else if ('phoneNumberByCountry' in validatorParams && fieldValue instanceof PhoneWithCountryCodeEntry) {
    var defaultRegex = /^\d+$/;

    var _regex = fieldValue.country in validatorParams.phoneNumberByCountry ? new RegExp(validatorParams.phoneNumberByCountry[fieldValue.country]) : defaultRegex; // only test against number component, not including country code


    if (!_regex.test(fieldValue.number)) {
      return {
        valid: false,
        errorMessage: validator.message
      };
    }
  }

  return {
    valid: true
  };
} // not just falsy check because 0 is not empty

function isEmptyValue(value) {
  return typeof value === 'undefined' || value === null || value === false || value === 'false' || // unchecked checkbox
  String(value) === '' // empty PhoneWithCountryCodeEntry converts to empty string
  ;
} // check whether a field is valid against its validators


function checkFieldValidity(field, value) {
  var valid = true;
  var errorMessages = [];

  if (field.model.required && isEmptyValue(value)) {
    var _field$model$validati;

    valid = false; // message from required validator

    var requiredMessage = ((_field$model$validati = field.model.validationDataModels.find(function (validationDataModel) {
      return validationDataModel.itemId === VALIDATORS.REQUIRED;
    })) === null || _field$model$validati === void 0 ? void 0 : _field$model$validati.message) || '';
    errorMessages.push(requiredMessage);
  } // only validate against other validators if value is populated


  if (!isEmptyValue(value)) {
    field.model.validationDataModels.forEach(function (validationDataModel) {
      var checkedData = validateDataModels(validationDataModel, value);

      if (!checkedData.valid) {
        valid = false;
        errorMessages.push(checkedData.errorMessage);
      }
    });
  }

  return {
    valid: valid,
    errorMessages: errorMessages
  };
} // this function is for updating labels when the field with value is updated

function validateCustomLabels(className, valid) {
  _toConsumableArray__default["default"](document.getElementsByClassName(className)).forEach(function (el) {
    if (valid) {
      el.classList.remove('invalid');
    } else {
      el.classList.add('invalid');
    }
  });
} // this function is for syncing labels when the field with conditions is updated

/**
 * @param {any} tracker
 * @param {ValueField} field
 * @param {props} props
 * @param {function} dispatch
 * @param {object} state
 *
 */

function handleOnBlur(field, props, dispatch) {
  var _checkFieldValidity = checkFieldValidity(field, Array.isArray(props.value) ? props.value[0] : props.value),
      valid = _checkFieldValidity.valid,
      errorMessages = _checkFieldValidity.errorMessages;

  validateCustomLabels(field.model.labelCssClass, valid); // create entry in field state if field hasn't been touched before
  // don't check for existence, unlike handleOnChange

  dispatch({
    type: 'update_field_state',
    fieldKey: field.valueField.name,
    value: errorMessages
  });
}

var baseInputClass = 'ccl__field-control__input ccl__text ccl__text--body-text';

var SingleLineTextField = function SingleLineTextField(props) {
  var _React$useContext = React__default["default"].useContext(FormContext),
      _React$useContext2 = _slicedToArray__default["default"](_React$useContext, 2),
      state = _React$useContext2[0],
      dispatch = _React$useContext2[1];

  var field = props.field,
      invalid = props.invalid,
      errors = props.errors,
      value = props.value,
      _onChange = props.onChange,
      _props$type = props.type,
      type = _props$type === void 0 ? 'text' : _props$type;
  var errorMsgId = "".concat(field.valueField.id, "-error-msg");
  var anchorId = "anchor-".concat(field.valueField.id);
  var hidden = useVisibility(_onChange, field, value);

  if (hidden) {
    return null;
  }

  var errorArray = checkValidations(errors, state.fieldState, field);
  var showError = errorArray && errorArray.length > 0;
  return /*#__PURE__*/React__default["default"].createElement("div", {
    className: "ccl__edit-mode__element"
  }, /*#__PURE__*/React__default["default"].createElement("div", {
    className: ['ccl__form-input', 'ccl__form-input--is-form-input', showError ? 'ccl__form-input--has-error' : ''].filter(function (val) {
      return val;
    }).join(' ')
  }, /*#__PURE__*/React__default["default"].createElement("span", {
    id: anchorId,
    className: "anchor"
  }), /*#__PURE__*/React__default["default"].createElement(Label, _extends__default["default"]({}, props, {
    key: "".concat(props.field.model.itemId, "_label")
  })), /*#__PURE__*/React__default["default"].createElement("div", {
    className: "ccl__field-control"
  }, /*#__PURE__*/React__default["default"].createElement("input", {
    type: type,
    className: "".concat(baseInputClass, " ").concat(field.model.cssClass),
    id: field.valueField.id,
    name: field.model.name,
    value: value,
    maxLength: field.model.maxLength,
    placeholder: field.model.placeholderText,
    onChange: function onChange(e) {
      return handleOnChange(field, e.target.value, _onChange, dispatch, state);
    },
    onBlur: function onBlur() {
      return handleOnBlur(field, props, dispatch);
    },
    onFocus: function onFocus() {
      return sendFormInteraction(field.model.title);
    },
    "aria-required": field.model.required,
    "aria-invalid": invalid,
    "aria-describedby": errorMsgId
  })), showError ? /*#__PURE__*/React__default["default"].createElement("p", {
    className: "ccl__form-input__error-message ccl__text ccl__text--error-small-text"
  }, /*#__PURE__*/React__default["default"].createElement("span", {
    className: "ccl__icon ccl__icon--error ccl__icon--color--error ccl__icon--size--xs"
  }), errorArray[0]) : null));
};
/**
 * Hidden field renderer, which is triggered when the class name of a text field is "__hidden"
 * @param {*} props field props
 * @returns Render of hidden field
 */


var HiddenField = function HiddenField(props) {
  var field = props.field,
      value = props.value;
  return /*#__PURE__*/React__default["default"].createElement("input", {
    type: "hidden",
    id: field.valueField.id,
    name: field.model.name,
    value: value
  });
};

var SingleLineText = function SingleLineText(props) {
  // call custom field based on class name
  switch (props.field.model.cssClass) {
    case '__hidden':
      return /*#__PURE__*/React__default["default"].createElement(HiddenField, props);

    default:
      return /*#__PURE__*/React__default["default"].createElement(SingleLineTextField, props);
  }
};

var Email = function Email(props) {
  return /*#__PURE__*/React__default["default"].createElement(SingleLineText, _extends__default["default"]({}, props, {
    type: "email"
  }));
};

var fetchReCaptchaToken = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator__default["default"]( /*#__PURE__*/_regeneratorRuntime__default["default"].mark(function _callee(reCaptchaSiteKey) {
    var promisifiedGrecaptchaReady, reCaptchaToken;
    return _regeneratorRuntime__default["default"].wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            promisifiedGrecaptchaReady = function promisifiedGrecaptchaReady() {
              return new Promise(function (resolve) {
                return grecaptcha.ready(resolve);
              });
            };

            _context.next = 3;
            return promisifiedGrecaptchaReady();

          case 3:
            _context.next = 5;
            return grecaptcha.execute(reCaptchaSiteKey, {
              action: 'submit'
            });

          case 5:
            reCaptchaToken = _context.sent;
            return _context.abrupt("return", reCaptchaToken);

          case 7:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function fetchReCaptchaToken(_x) {
    return _ref.apply(this, arguments);
  };
}();

var getGAClientId = function getGAClientId() {
  if (typeof window.ga !== 'function') {
    return null;
  }

  var clientId = '';
  window.ga(function () {
    clientId = window.ga.getAll()[0].get('clientId');
  });
  return clientId;
};

function ownKeys$2(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$2(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$2(Object(source), !0).forEach(function (key) { _defineProperty__default["default"](target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$2(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var submitToMarketo = function submitToMarketo(submissionObject, instanceParameters, reCaptchaSiteKey, successCallback) {
  var submissionUrl = instanceParameters.submissionUrl,
      instanceId = instanceParameters.instanceId,
      formId = instanceParameters.formId;
  var errorHandlerTimeout = 30000;
  var errorHandler = null;

  var SubmitForm = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator__default["default"]( /*#__PURE__*/_regeneratorRuntime__default["default"].mark(function _callee() {
      var reCaptchaToken, _submit, uniqueKey;

      return _regeneratorRuntime__default["default"].wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return fetchReCaptchaToken(reCaptchaSiteKey);

            case 2:
              reCaptchaToken = _context.sent;
              _submit = _objectSpread$2(_objectSpread$2({}, submissionObject), {}, {
                googleAnalyticsClientID: getGAClientId(),
                captchaToken: reCaptchaToken
              });
              uniqueKey = Symbol(); // workaround for marketo script looking for `siteKey` instead of `sitekey` from API response

              Object.defineProperty(Object.prototype, 'siteKey', {
                get: function get() {
                  return this.hasOwnProperty(uniqueKey) ? this[uniqueKey] : this.sitekey;
                },
                set: function set(value) {
                  return this[uniqueKey] = value;
                }
              });

              if (typeof window.MktoForms2 !== 'undefined') {
                window.MktoForms2.loadForm(submissionUrl === null || submissionUrl === void 0 ? void 0 : submissionUrl.value, instanceId === null || instanceId === void 0 ? void 0 : instanceId.value, formId === null || formId === void 0 ? void 0 : formId.value, function (form) {
                  form.addHiddenFields(_submit);
                  form.onSubmit(function (response) {
                    // set a timer to handle error if endpoint is unavailable
                    errorHandler = setTimeout(function () {
                      console.log('Marketo is unavailable');
                      var error = true;
                      successCallback({
                        error: error
                      });
                      return false;
                    }, errorHandlerTimeout);
                  }).submit().onSuccess(function (response) {
                    clearTimeout(errorHandler);
                    successCallback();
                    return false;
                  }); // .onError()	// 	No error handling available in Marketo :(
                });
              }

              return _context.abrupt("return", null);

            case 8:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function SubmitForm() {
      return _ref.apply(this, arguments);
    };
  }();

  return SubmitForm();
};

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
var INTEREST_FIELD_PREFIX = '__interests__';
var DELIVERY_METHOD_FIELD_NAME = 'deliveryMethod';
/**
 * Wrapper on top of existing Marketo submit hook to add logic specific to downloading assets
 * @param {*} submissionObject
 * @param {*} instanceParameters
 * @param {*} redirectLink
 * @param {*} form
 * @param {*} successCallback
 */

var submitDownloadGatedAsset = function submitDownloadGatedAsset(submissionObject, instanceParameters, redirectLink, form, reCaptchaSiteKey, pushSubmitResult) {
  var baseUrl = new URL(redirectLink === null || redirectLink === void 0 ? void 0 : redirectLink.value.href, window.location.origin); // asset details cannot be retrieved using an api
  // hence need to pass the name of the asset (from the checkbox list) to the url
  // gather all interest fields from initial form fields

  var interestList = [];

  function checkInterestField(field) {
    if (field.model.name.startsWith(INTEREST_FIELD_PREFIX)) {
      interestList.push.apply(interestList, _toConsumableArray__default["default"](field.model.items));
    }

    if (field.fields) {
      var _iterator = _createForOfIteratorHelper(field.fields),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var innerField = _step.value;
          checkInterestField(innerField);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
  }

  var _iterator2 = _createForOfIteratorHelper(form.fields),
      _step2;

  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var field = _step2.value;
      checkInterestField(field);
    } // each interest is in the format "<identifier> <documentNumber> <versionNumber>"
    // each field has values separated by the delimiter

  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }

  var interestsFields = Object.entries(submissionObject).filter(function (_ref) {
    var _ref2 = _slicedToArray__default["default"](_ref, 1),
        key = _ref2[0];

    return key.startsWith(INTEREST_FIELD_PREFIX);
  });
  var interestsArr = interestsFields.flatMap(function (_ref3) {
    var _ref4 = _slicedToArray__default["default"](_ref3, 2),
        value = _ref4[1];

    return value.split(DELIMITERS.CHECKBOX_LIST);
  }).map(function (str) {
    return str.split(' ');
  });
  var identifiers = interestsArr.map(function (parts) {
    return parts[0];
  });
  var documentAndVersions = interestsArr.filter(function (parts) {
    return parts[1] && parts[2];
  }).map(function (parts) {
    return "".concat(parts[1], " ").concat(parts[2]);
  }); // preserve order of asset list - match user selected values to original asset list order
  // output object keys are the identifiers
  // output object values are the display name

  var interestObj = Object.fromEntries(interestList.map(function (item) {
    return [item.value.split(' ')[0], item.text];
  }).filter(function (_ref5) {
    var _ref6 = _slicedToArray__default["default"](_ref5, 1),
        value = _ref6[0];

    return identifiers.includes(value);
  })); // params for thank you url

  var searchParams = new URLSearchParams(baseUrl.searchParams);
  searchParams.set('interests', JSON.stringify(interestObj));

  if (submissionObject[DELIVERY_METHOD_FIELD_NAME] === 'Download and via post') {
    searchParams.set('post', 'true');
  } // marketo wants the url without the protocol


  var thankYouURL = "".concat(baseUrl.host).concat(baseUrl.pathname, "?").concat(searchParams.toString()); // additional fields for submission object

  submissionObject.thankYouURL = thankYouURL; // don't send if field is empty

  if (documentAndVersions.length > 0) {
    submissionObject.assetIds = ";".concat(documentAndVersions.join(';'), ";");
  }

  interestsFields.forEach(function (_ref7) {
    var _ref8 = _slicedToArray__default["default"](_ref7, 1),
        key = _ref8[0];

    delete submissionObject[key];
  });
  return submitToMarketo(submissionObject, instanceParameters, reCaptchaSiteKey, function (err) {
    return pushSubmitResult(err, "//".concat(thankYouURL));
  });
};

function ownKeys$1(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$1(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$1(Object(source), !0).forEach(function (key) { _defineProperty__default["default"](target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$1(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
/**
 * Submit form to Salesforce WebToCase / WebToMail
 * @param {Object} submissionObject JSON consisting of the values of all the form fields
 * @param {Any} callback Contains callback handler functions which trigger the parent component state values
 */

var submitToSalesforceCase = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator__default["default"]( /*#__PURE__*/_regeneratorRuntime__default["default"].mark(function _callee(submissionObject, instanceParameters, reCaptchaSiteKey, successCallback) {
    var webToCaseUrl, buildUtmEntries, digitalTrackingData, reCaptchaToken, endpoint, _submit;

    return _regeneratorRuntime__default["default"].wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            webToCaseUrl = instanceParameters.webToCaseUrl;
            buildUtmEntries = ['utm_campaign', 'utm_content', 'utm_creative_format', 'utm_id', 'utm_marketing_tactic', 'utm_medium', 'utm_source', 'utm_source_platform', 'utm_term'].map(function (key) {
              return [key.replace(/_([a-z])/g, function (match, p1) {
                return p1.toUpperCase();
              }), sessionStorage.getItem(key) || ''];
            });
            digitalTrackingData = _objectSpread$1(_objectSpread$1({}, Object.fromEntries(buildUtmEntries)), {}, {
              googleAnalyticsClientId: getGAClientId(),
              facebookId: sessionStorage.getItem('fbclid'),
              webformUrl: window.location.href
            });
            _context.prev = 3;
            _context.next = 6;
            return fetchReCaptchaToken(reCaptchaSiteKey);

          case 6:
            reCaptchaToken = _context.sent;
            endpoint = webToCaseUrl !== null && webToCaseUrl !== void 0 && webToCaseUrl.value.startsWith('https://') ? webToCaseUrl.value : "//".concat(webToCaseUrl.value, "/forcely/webtocase/");
            _submit = _objectSpread$1(_objectSpread$1(_objectSpread$1({}, submissionObject), digitalTrackingData), {}, {
              reCaptchaToken: reCaptchaToken
            });
            _context.next = 11;
            return axios__default["default"].post(endpoint, _submit);

          case 11:
            successCallback();
            _context.next = 19;
            break;

          case 14:
            _context.prev = 14;
            _context.t0 = _context["catch"](3);
            console.log(_context.t0);
            successCallback({
              err: _context.t0
            });
            throw _context.t0;

          case 19:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[3, 14]]);
  }));

  return function submitToSalesforceCase(_x, _x2, _x3, _x4) {
    return _ref.apply(this, arguments);
  };
}();

function mergeJourneyStageYesNo(submissionObject) {
  if (submissionObject !== null && submissionObject !== void 0 && submissionObject.__JourneyStage_Yes__) {
    submissionObject.JourneyStage__c = submissionObject.__JourneyStage_Yes__;
  } else if (submissionObject !== null && submissionObject !== void 0 && submissionObject.__JourneyStage_No__) {
    submissionObject.JourneyStage__c = submissionObject.__JourneyStage_No__;
  }

  delete submissionObject.__JourneyStage_Yes__;
  delete submissionObject.__JourneyStage_No__;
}

function splitParametersHack(submissionObject) {
  var typeSegment = submissionObject['__TypeSegment__'];

  if (!typeSegment) {
    return;
  }

  switch (typeSegment) {
    case '__TypeSegment_Myself__':
      submissionObject['RecordTypeId'] = '0125g000000Co32AAC';
      submissionObject['PatientAgeSegment__c'] = 'Adult';
      break;

    case '__TypeSegment_Child__':
      submissionObject['RecordTypeId'] = '0126N000000GsqpQAC';
      submissionObject['PatientAgeSegment__c'] = 'Pediatrics';
      break;

    case '__TypeSegment_LovedOne__':
      submissionObject['RecordTypeId'] = '0126N000000GsqpQAC';
      submissionObject['PatientAgeSegment__c'] = 'Senior';
      break;
  }

  delete submissionObject['__TypeSegment__'];
}

function maybeTrimDuplicate(value) {
  var DUPLICATE_REGEX = /\$\$duplicate[0-9]*$/;

  if (typeof value === 'string' && DUPLICATE_REGEX.test(value)) {
    return value.replace(DUPLICATE_REGEX, '');
  }

  return value;
}

function getSalesforceCountry(iso3166) {
  var countryCodeMap = {
    AD: 'Andorra',
    AE: 'United Arab Emirates',
    AF: 'Afghanistan',
    AG: 'Antigua And Barbuda',
    AI: 'Anguilla',
    AL: 'Albania',
    AM: 'Armenia',
    AN: 'Netherlands Antilles',
    AO: 'Angola',
    AQ: 'Antarctica',
    AR: 'Argentina',
    AS: 'American Samoa, US',
    AT: 'Austria',
    AU: 'Australia',
    AW: 'Aruba',
    AX: 'Aland Islands',
    AZ: 'Azerbaijan',
    BA: 'Bosnia And Herzegovina',
    BB: 'Barbados',
    BD: 'Bangladesh',
    BE: 'Belgium',
    BF: 'Burkina Faso',
    BG: 'Bulgaria',
    BH: 'Bahrain',
    BI: 'Burundi',
    BJ: 'Benin',
    BL: 'Saint Barthélemy',
    BM: 'Bermuda',
    BN: 'Brunei',
    BO: 'Bolivia',
    BR: 'Brazil',
    BS: 'Bahamas',
    BT: 'Bhutan',
    BV: 'Bouvet Island',
    BW: 'Botswana',
    BY: 'Belarus',
    BZ: 'Belize',
    CA: 'Canada',
    CC: 'Cocos (Keeling) Islands',
    CD: 'Congo, the Democratic Republic of the',
    CF: 'Central African Republic',
    CG: 'Congo, the Republic of the',
    CH: 'Switzerland',
    CI: "Cote d'Ivoire",
    CK: 'Cook Islands',
    CL: 'Chile',
    CM: 'Cameroon',
    CN: 'China',
    CO: 'Colombia',
    CR: 'Costa Rica',
    CU: 'Cuba',
    CV: 'Cape Verde',
    CX: 'Christmas Island',
    CY: 'Cyprus',
    CZ: 'Czech Republic',
    DE: 'Germany',
    DJ: 'Djibouti',
    DK: 'Denmark',
    DM: 'Dominica',
    DO: 'Dominican Republic',
    DZ: 'Algeria',
    EC: 'Ecuador',
    EE: 'Estonia',
    EG: 'Egypt',
    EH: 'Western Sahara',
    ER: 'Eritrea',
    ES: 'Spain',
    ET: 'Ethiopia',
    FI: 'Finland',
    FJ: 'Fiji',
    FK: 'Falkland Islands (Malvinas)',
    FM: 'Micronesia, Federated States Of',
    FO: 'Faroe Islands',
    FR: 'France',
    GA: 'Gabon',
    GB: 'United Kingdom',
    GD: 'Grenada',
    GE: 'Georgia',
    GF: 'French Guiana',
    GG: 'Guernsey',
    GH: 'Ghana',
    GI: 'Gibraltar',
    GL: 'Greenland',
    GM: 'Gambia',
    GN: 'Guinea',
    GP: 'Guadeloupe',
    GQ: 'Equatorial Guinea',
    GR: 'Greece',
    GS: 'South Georgia and the South Sandwich Islands',
    GT: 'Guatemala',
    GU: 'Guam, US',
    GW: 'Guinea-Bissau',
    GY: 'Guyana',
    HK: 'Hong Kong',
    HM: 'Heard Island and McDonald Islands',
    HN: 'Honduras',
    HR: 'Croatia',
    HT: 'Haiti',
    HU: 'Hungary',
    ID: 'Indonesia',
    IE: 'Ireland',
    IL: 'Israel',
    IM: 'Isle Of Man',
    IN: 'India',
    IO: 'British Indian Ocean Territory',
    IQ: 'Iraq',
    IR: 'Iran, Islamic Republic Of',
    IS: 'Iceland',
    IT: 'Italy',
    JE: 'Jersey',
    JM: 'Jamaica',
    JO: 'Jordan',
    JP: 'Japan',
    KE: 'Kenya',
    KG: 'Kyrgyzstan',
    KH: 'Cambodia',
    KI: 'Kiribati',
    KM: 'Comoros',
    KN: 'Saint Kitts And Nevis',
    KP: "Korea, Democratic People's Republic of",
    KR: 'Korea, Republic of',
    KW: 'Kuwait',
    KY: 'Cayman Islands',
    KZ: 'Kazakhstan',
    LA: 'Laos',
    LB: 'Lebanon',
    LC: 'Saint Lucia',
    LI: 'Liechtenstein',
    LK: 'Sri Lanka',
    LR: 'Liberia',
    LS: 'Lesotho',
    LT: 'Lithuania',
    LU: 'Luxembourg',
    LV: 'Latvia',
    LY: 'Libya',
    MA: 'Morocco',
    MC: 'Monaco',
    MD: 'Moldova, Republic of',
    ME: 'Montenegro',
    MF: 'Saint Martin (French part)',
    MG: 'Madagascar',
    MH: 'Marshall Islands',
    MK: 'North Macedonia',
    ML: 'Mali',
    MM: 'Myanmar',
    MN: 'Mongolia',
    MO: 'Macao',
    MP: 'Northern Mariana Islands, US',
    MQ: 'Martinique',
    MR: 'Mauritania',
    MS: 'Montserrat',
    MT: 'Malta',
    MU: 'Mauritius',
    MV: 'Maldives',
    MW: 'Malawi',
    MX: 'Mexico',
    MY: 'Malaysia',
    MZ: 'Mozambique',
    NA: 'Namibia',
    NC: 'New Caledonia',
    NE: 'Niger',
    NF: 'Norfolk Island',
    NG: 'Nigeria',
    NI: 'Nicaragua',
    NL: 'Netherlands',
    NO: 'Norway',
    NP: 'Nepal',
    NR: 'Nauru',
    NU: 'Niue',
    NZ: 'New Zealand',
    OM: 'Oman',
    PA: 'Panama',
    PE: 'Peru',
    PF: 'French Polynesia',
    PG: 'Papua New Guinea',
    PH: 'Philippines',
    PK: 'Pakistan',
    PL: 'Poland',
    PM: 'Saint Pierre And Miquelon',
    PN: 'Pitcairn',
    PR: 'Puerto Rico, US',
    PS: 'Palestine, State of',
    PT: 'Portugal',
    PW: 'Palau',
    PY: 'Paraguay',
    QA: 'Qatar',
    RE: 'Reunion',
    RO: 'Romania',
    RS: 'Serbia',
    RU: 'Russian Federation',
    RW: 'Rwanda',
    SA: 'Saudi Arabia',
    SB: 'Solomon Islands',
    SC: 'Seychelles',
    SD: 'Sudan',
    SE: 'Sweden',
    SG: 'Singapore',
    SH: 'Saint Helena, Ascension and Tristan da Cunha',
    SI: 'Slovenia',
    SJ: 'Svalbard And Jan Mayen',
    SK: 'Slovakia',
    SL: 'Sierra Leone',
    SM: 'San Marino',
    SN: 'Senegal',
    SO: 'Somalia',
    SR: 'Suriname',
    ST: 'Sao Tome And Principe',
    SV: 'El Salvador',
    SY: 'Syrian Arab Republic',
    SZ: 'Swaziland',
    TC: 'Turks And Caicos Islands',
    TD: 'Chad',
    TF: 'French Southern Territories',
    TG: 'Togo',
    TH: 'Thailand',
    TJ: 'Tajikistan',
    TK: 'Tokelau',
    TL: 'Timor-Leste',
    TM: 'Turkmenistan',
    TN: 'Tunisia',
    TO: 'Tonga',
    TR: 'Turkey',
    TT: 'Trinidad And Tobago',
    TV: 'Tuvalu',
    TW: 'Taiwan',
    TZ: 'Tanzania',
    UA: 'Ukraine',
    UG: 'Uganda',
    UM: 'United States Minor Outlying Islands',
    US: 'United States',
    UY: 'Uruguay',
    UZ: 'Uzbekistan',
    VA: 'Vatican City, Holy See',
    VC: 'Saint Vincent and the Grenadines',
    VE: 'Venezuela',
    VG: 'Virgin Islands, British',
    VI: 'Virgin Islands, US',
    VN: 'Vietnam',
    VU: 'Vanuatu',
    WF: 'Wallis And Futuna',
    WS: 'Samoa',
    YE: 'Yemen',
    YT: 'Mayotte',
    ZA: 'South Africa',
    ZM: 'Zambia',
    ZW: 'Zimbabwe'
  };
  return countryCodeMap[iso3166];
}

function handleSubmit(e, field, props, state, dispatch) {
  var additionalFields = props.additionalFields,
      onButtonClick = props.onButtonClick,
      onSubmitResult = props.onSubmitResult,
      formComponent = props.formComponent,
      instanceParameters = props.instanceParameters,
      reCaptchaSiteKey = props.reCaptchaSiteKey,
      redirectLink = props.redirectLink,
      form = props.formComponent.current.props.form; // we never want to store data in sc, therefore preventDefault

  e.preventDefault();
  onButtonClick(field.buttonField.name); // Hook into jss form component to overwrite default submission behaviour
  //Serialize the initial form data

  var formData = sitecoreJssForms.serializeForm(form, {
    submitButtonName: field.buttonField.name
  }); // merge in user-updated field values

  var fieldValues = {};
  var currentFieldValues = formComponent.current.collectCurrentFieldValues();
  currentFieldValues.forEach(function (field) {
    if (typeof field.state.value !== 'undefined') {
      fieldValues[field.fieldName] = field.state.value;
    }
  });
  formData.mergeOverwritingExisting(fieldValues);
  formData.data = formData.data.filter(function (item) {
    return item.key.indexOf('Value') >= 0;
  });
  var formFieldNames = mapIdToFieldName(form); // match form data to correct names and prepare data for submission

  var submissionObject = formData.data.reduce(function (acc, curr) {
    var _name = formFieldNames.get(curr.key); // multiple values checkbox list can have multiple identical keys
    // send all values separated by semicolon - Salesforce/Marketo multifield delimiter


    acc[_name] = _name in acc ? [acc[_name], curr.value].join(DELIMITERS.CHECKBOX_LIST) : curr.value;
    return acc;
  }, {});
  var validationResult = validateDataAllFields(form, submissionObject, {
    dispatch: dispatch,
    state: state
  });

  if (validationResult.length > 0) {
    sendFormSubmitValidationError(validationResult); // prevent submission on error

    return false;
  }

  if (additionalFields) {
    for (var fieldName in additionalFields) {
      if (!(fieldName in submissionObject)) {
        submissionObject[fieldName] = additionalFields[fieldName];
      }
    }
  }

  mergeJourneyStageYesNo(submissionObject);
  splitParametersHack(submissionObject); // copy JourneyStage__c to interestIndicatedJourneyStage

  if ('JourneyStage__c' in submissionObject && !('interestIndicatedJourneyStage' in submissionObject)) {
    submissionObject.interestIndicatedJourneyStage = submissionObject.JourneyStage__c;
  } // take state field from variable state fields


  var variableState = Object.entries(submissionObject).find(function (_ref) {
    var _ref2 = _slicedToArray__default["default"](_ref, 1),
        key = _ref2[0];

    return key.startsWith('__State');
  });

  if (variableState) {
    submissionObject.StateCode = variableState[1];
    delete submissionObject[variableState[0]];
  } // map salesforce country name


  if ('CountryofResidence__c' in submissionObject) {
    var countryCode = submissionObject.CountryofResidence__c.toUpperCase();
    var mappedCountry = getSalesforceCountry(countryCode);
    submissionObject.CountryofResidence__c = mappedCountry; // also send CountryCode field if any address fields are present

    if (['Address', 'City', 'StateCode', 'PostalCode'].some(function (field) {
      return field in submissionObject;
    }) && !('CountryCode' in submissionObject)) {
      submissionObject.CountryCode = countryCode;
    } // backwards compatibility - send Country if sending State


    if ('State' in submissionObject && !('Country' in submissionObject)) {
      submissionObject.Country = mappedCountry;
    }
  } // combine data collection fields


  var dataCollectionFields = ['dataCollectionFirstName', 'dataCollectionLastName', 'dataCollectionEmail', 'dataCollectionWorkMobilePhone', 'dataCollectionProfession', 'dataCollectionClinicOrganizationName', 'dataCollectionWorkZipCode', 'dataCollectionPreferredCenterSurgeon'].filter(function (field) {
    return field in submissionObject;
  });

  if (dataCollectionFields.length > 0) {
    submissionObject.multipurpose1 = [['First name', submissionObject.dataCollectionFirstName], ['Last name', submissionObject.dataCollectionLastName], ['Email', submissionObject.dataCollectionEmail], ['Work phone number', submissionObject.dataCollectionWorkMobilePhone], ['Profession', submissionObject.dataCollectionProfession], ['Clinic or organization name', submissionObject.dataCollectionClinicOrganizationName], ['Work zip code', submissionObject.dataCollectionWorkZipCode], ['Preferred center/CI surgeon', submissionObject.dataCollectionPreferredCenterSurgeon]].filter(function (_ref3) {
      var _ref4 = _slicedToArray__default["default"](_ref3, 2),
          value = _ref4[1];

      return value;
    }).map(function (_ref5) {
      var _ref6 = _slicedToArray__default["default"](_ref5, 2),
          label = _ref6[0],
          value = _ref6[1];

      return "".concat(label, ": ").concat(value);
    }).join('\n');
    dataCollectionFields.forEach(function (field) {
      delete submissionObject[field];
    });
  }

  submissionObject['interestCaptureDate'] = new Date().toISOString();

  var mapParamToField = function mapParamToField(param, fieldName) {
    var params = new URLSearchParams(window.location.search); // don't override if already in form values

    if (params.has(param) && !(fieldName in submissionObject)) {
      submissionObject[fieldName] = params.get(param);
    }
  }; // interest parameters from url


  mapParamToField('int_type', 'interestType');
  mapParamToField('int_subreason', 'interestSubReason');
  mapParamToField('int_productfamily', 'interestProductFamily');
  mapParamToField('int_product', 'interestProduct'); // provider id for referral lead professional forms

  mapParamToField('providerId', 'HealthCloudGA__ReferringOrganization__c');

  var mapSessionStorageToField = function mapSessionStorageToField(sessionStorageKey, fieldName) {
    var value = sessionStorage.getItem(sessionStorageKey);

    if (value) {
      submissionObject[fieldName] = value;
    }
  };

  mapSessionStorageToField('utm_campaign', 'uTMCampaign');
  mapSessionStorageToField('utm_content', 'uTMContent');
  mapSessionStorageToField('utm_medium', 'uTMMedium');
  mapSessionStorageToField('utm_source', 'uTMSource');
  mapSessionStorageToField('utm_term', 'uTMTerm');
  mapSessionStorageToField('volunteerMentorCode', 'volunteerEmailAddress');

  var handleSubmitResult = function handleSubmitResult(err, overrideRedirectURL) {
    var shouldRedirect = field.model.submitActions.some(function (_ref7) {
      var submitActionId = _ref7.submitActionId;
      return submitActionId === ACTIONS['REDIRECT_TO_PAGE'];
    });

    if (!err) {
      sendFormSubmitSuccess();
    }

    if (shouldRedirect && !err) {
      window.location.href = overrideRedirectURL !== null && overrideRedirectURL !== void 0 ? overrideRedirectURL : redirectLink === null || redirectLink === void 0 ? void 0 : redirectLink.value.href;
    } else {
      onSubmitResult(err ? 'error' : 'success');
    }
  };

  Object.entries(submissionObject).forEach(function (_ref8) {
    var _ref9 = _slicedToArray__default["default"](_ref8, 2),
        key = _ref9[0],
        value = _ref9[1];

    if (value instanceof PhoneWithCountryCodeEntry) {
      submissionObject[key] = String(value);
    }
  }); // removal of duplicate suffix

  Object.entries(submissionObject).forEach(function (_ref10) {
    var _ref11 = _slicedToArray__default["default"](_ref10, 2),
        key = _ref11[0],
        value = _ref11[1];

    submissionObject[key] = maybeTrimDuplicate(value);
  });
  field.model.submitActions.forEach(function (submitAction) {
    switch (submitAction.submitActionId) {
      case ACTIONS['SUBMIT_DOWNLOAD_GATED_ASSET_TO_MARKETO']:
        submitDownloadGatedAsset(submissionObject, instanceParameters.fields, redirectLink, form, reCaptchaSiteKey, handleSubmitResult);
        break;

      case ACTIONS['SUBMIT_TO_MARKETO']:
        submitToMarketo(submissionObject, instanceParameters.fields, reCaptchaSiteKey, handleSubmitResult);
        break;

      case ACTIONS['SUBMIT_TO_SF']:
        submitToSalesforceCase(submissionObject, instanceParameters.fields, reCaptchaSiteKey, handleSubmitResult);
        break;
    }
  });
  return validationResult;
} // Creates a map of all submittable fields from name-id-value to field-name:
// "fxb.71b12f51-a0ec-4eb3-9621-acfd8e87a660.Fields[71e19009-4bc3-4540-838c-03a075c1b95f].Value => fieldName

function mapIdToFieldName(form) {
  var map = new Map();

  var fieldReducer = function fieldReducer(valueMap, currentField) {
    // recursively find values in the form
    // recurse on "fields"
    if (currentField.fields) {
      currentField.fields.reduce(fieldReducer, valueMap);
    } //Skip if current field has no value


    if (!currentField.valueField) {
      return valueMap;
    } // update map model field name : submission field name


    valueMap.set(currentField.valueField.name, currentField.model.name);
    return valueMap;
  };

  return form.fields.reduce(fieldReducer, map);
}

function validateDataAllFields(form, submitObject, formContext) {
  var dispatch = formContext.dispatch,
      state = formContext.state;

  var fieldReducer = function fieldReducer(acc, currentField) {
    // handle hidden fields
    // - don't throw validation errors
    // - delete the field from the submission
    if (checkConditions(state.fieldValues, state.conditions[currentField.model.conditionSettings.fieldKey])) {
      delete submitObject[currentField.model.name];
      return acc;
    } // recursively find fields in the form


    if (currentField.fields) {
      return currentField.fields.reduce(fieldReducer, acc);
    } //Skip if current field has no value


    if (!currentField.valueField) {
      return acc;
    }

    var _checkFieldValidity = checkFieldValidity(currentField, submitObject[currentField.model.name]),
        valid = _checkFieldValidity.valid,
        errorMessages = _checkFieldValidity.errorMessages;

    validateCustomLabels(currentField.model.labelCssClass, valid);
    dispatch({
      type: 'update_field_state',
      fieldKey: currentField.valueField.name,
      value: errorMessages
    });

    if (!valid) {
      //accumulate invalid fields for analytics purposes.
      acc.push(currentField.model.name);
    }

    return acc;
  }; // assume all fields valid to begin


  return form.fields.reduce(fieldReducer, []);
}

// function App() {
//   const status = useScript(
//     "https://pm28k14qlj.codesandbox.io/test-external-script.js"
//   );
//   return (
//     <div>
//       <div>
//         Script status: <b>{status}</b>
//       </div>
//       {status === "ready" && (
//         <div>
//           Script function call response: <b>{TEST_SCRIPT.start()}</b>
//         </div>
//       )}
//     </div>
//   );
// }
// Hook

var useScript = function useScript(src) {
  // Keep track of script status ("idle", "loading", "ready", "error")
  var _useState = React.useState(src ? "loading" : "idle"),
      _useState2 = _slicedToArray__default["default"](_useState, 2),
      status = _useState2[0],
      setStatus = _useState2[1];

  React.useEffect(function () {
    // Allow falsy src value if waiting on other data needed for
    // constructing the script URL passed to this hook.
    if (!src) {
      setStatus("idle");
      return;
    } // Fetch existing script element by src
    // It may have been added by another intance of this hook


    var script = document.querySelector("script[src=\"".concat(src, "\"]"));

    if (!script) {
      // Create script
      script = document.createElement("script");
      script.src = src;
      script.async = true;
      script.setAttribute("data-status", "loading"); // Add script to document body

      document.body.appendChild(script); // Store status in attribute on script
      // This can be read by other instances of this hook

      var setAttributeFromEvent = function setAttributeFromEvent(event) {
        script.setAttribute("data-status", event.type === "load" ? "ready" : "error");
      };

      script.addEventListener("load", setAttributeFromEvent);
      script.addEventListener("error", setAttributeFromEvent);
    } else {
      // Grab existing script status from attribute and set to state.
      setStatus(script.getAttribute("data-status"));
    } // Script event handler to update status in state
    // Note: Even if the script already exists we still need to add
    // event handlers to update the state for *this* hook instance.


    var setStateFromEvent = function setStateFromEvent(event) {
      setStatus(event.type === "load" ? "ready" : "error");
    }; // Add event listeners


    script.addEventListener("load", setStateFromEvent);
    script.addEventListener("error", setStateFromEvent); // Remove event listeners on cleanup

    return function () {
      if (script) {
        script.removeEventListener("load", setStateFromEvent);
        script.removeEventListener("error", setStateFromEvent);
      }
    };
  }, [src] // Only re-run effect if script src changes
  );
  return status;
};

var Button = function Button(props) {
  var _useState = React.useState(false),
      _useState2 = _slicedToArray__default["default"](_useState, 2),
      clicked = _useState2[0],
      setClicked = _useState2[1];

  var _React$useContext = React__default["default"].useContext(FormContext),
      _React$useContext2 = _slicedToArray__default["default"](_React$useContext, 2),
      state = _React$useContext2[0],
      dispatch = _React$useContext2[1];

  var field = props.field,
      reCaptchaSiteKey = props.reCaptchaSiteKey;
  var isMarketoRequired = field.model.submitActions.some(function (_ref) {
    var submitActionId = _ref.submitActionId;
    return submitActionId === ACTIONS['SUBMIT_TO_MARKETO'] || submitActionId === ACTIONS['SUBMIT_DOWNLOAD_GATED_ASSET_TO_MARKETO'];
  }); // both marketo and salesforce require recaptcha loaded

  var reCaptchaScriptStatus = useScript("https://www.google.com/recaptcha/api.js?render=".concat(reCaptchaSiteKey)); // load marketo script after recaptcha

  var marketoScriptStatus = useScript(reCaptchaScriptStatus === 'ready' && isMarketoRequired ? 'https://go.cochlear.com/js/forms2/js/forms2.min.js' : '');

  var handleClick = function handleClick(evt) {
    var fieldsValid = handleSubmit(evt, field, props, state, dispatch);

    if (fieldsValid) {
      setClicked(true);
    }
  };

  var scriptLoaded = reCaptchaScriptStatus === 'ready' && (!isMarketoRequired || marketoScriptStatus === 'ready');
  var loading = !scriptLoaded || !!clicked;
  return /*#__PURE__*/React__default["default"].createElement("div", null, /*#__PURE__*/React__default["default"].createElement("button", {
    type: "submit",
    className: ['ccl__button', 'ccl__button--brand-primary', 'ccl__button--large', 'cta', loading ? 'been-clicked' : ''].filter(function (val) {
      return val;
    }).join(' '),
    disabled: loading,
    id: field.buttonField.id,
    name: field.buttonField.name,
    onClick: handleClick
  }, /*#__PURE__*/React__default["default"].createElement("span", {
    className: "ccl__button__text"
  }, field.model.title), /*#__PURE__*/React__default["default"].createElement("div", {
    className: "lds-ring"
  }, /*#__PURE__*/React__default["default"].createElement("div", null), /*#__PURE__*/React__default["default"].createElement("div", null), /*#__PURE__*/React__default["default"].createElement("div", null), /*#__PURE__*/React__default["default"].createElement("div", null))));
};

var Checkbox = function Checkbox(props) {
  var _React$useContext = React__default["default"].useContext(FormContext),
      _React$useContext2 = _slicedToArray__default["default"](_React$useContext, 2),
      state = _React$useContext2[0],
      dispatch = _React$useContext2[1];

  var field = props.field,
      value = props.value,
      _onChange = props.onChange,
      errors = props.errors;
  var anchorId = "anchor-".concat(field.valueField.id);
  var errorMsgId = "".concat(field.valueField.id, "-error-msg");
  var hidden = useVisibility(_onChange, field, value);

  if (hidden) {
    return null;
  }

  var errorArray = checkValidations(errors, state.fieldState, field);
  var showError = errorArray && errorArray.length > 0;
  return /*#__PURE__*/React__default["default"].createElement("div", {
    className: "ccl__edit-mode__element"
  }, /*#__PURE__*/React__default["default"].createElement("div", {
    className: "ccl__form-input"
  }, /*#__PURE__*/React__default["default"].createElement("span", {
    id: anchorId,
    className: "anchor"
  }), /*#__PURE__*/React__default["default"].createElement("div", {
    className: "ccl__field-control ccl__field-control--input-selectors"
  }, showError ? /*#__PURE__*/React__default["default"].createElement("p", {
    className: "ccl__form-input__error-message ccl__text ccl__text--error-small-text"
  }, /*#__PURE__*/React__default["default"].createElement("span", {
    className: "ccl__icon ccl__icon--error ccl__icon--color--error ccl__icon--size--sm"
  }), errorArray[0]) : null, /*#__PURE__*/React__default["default"].createElement("label", {
    htmlFor: field.valueField.id,
    className: "ccl__field-control__label ccl__field-control__label--is-checkbox ccl__text ccl__text--body-text",
    key: field.valueField.id
  }, /*#__PURE__*/React__default["default"].createElement("span", {
    dangerouslySetInnerHTML: {
      __html: field.model.title
    }
  }), /*#__PURE__*/React__default["default"].createElement("input", {
    "aria-checked": value,
    "aria-describedby": errorMsgId,
    checked: value,
    className: "ccl__field-control__label__input",
    id: field.valueField.id,
    name: field.model.name,
    onBlur: function onBlur() {
      return handleOnBlur(field, props, dispatch);
    },
    onChange: function onChange(e) {
      return handleOnChange(field, e.target.checked, _onChange, dispatch, state);
    },
    onFocus: function onFocus() {
      return sendFormInteraction(field.model.title);
    },
    type: "checkbox",
    value: "true"
  }), /*#__PURE__*/React__default["default"].createElement("div", {
    className: "ccl__field-control__indicator"
  })))));
};

var CheckboxList = function CheckboxList(props) {
  var _React$useContext = React__default["default"].useContext(FormContext),
      _React$useContext2 = _slicedToArray__default["default"](_React$useContext, 2),
      state = _React$useContext2[0],
      dispatch = _React$useContext2[1];

  var field = props.field,
      items = props.field.model.items,
      value = props.value,
      onChange = props.onChange,
      errors = props.errors;
  var anchorId = "anchor-".concat(field.valueField.id);
  var errorMsgId = "".concat(field.valueField.id, "-error-msg");
  var hidden = useVisibility(onChange, field, value);

  if (hidden) {
    return null;
  }

  var handleChange = function handleChange(evt) {
    // we can have multiple selected values. So we need to push ALL the selected
    // values back up to the root form. This is done using an array, which the form
    // serializer knows how to expand into multiple values on post
    var newValues = evt.target.checked ? [].concat(_toConsumableArray__default["default"](value), [evt.target.value]) : value.filter(function (val) {
      return val !== evt.target.value;
    });
    handleOnChange(field, newValues, onChange, dispatch, state);
  };

  var errorArray = checkValidations(errors, state.fieldState, field);
  var showError = errorArray && errorArray.length > 0;
  return /*#__PURE__*/React__default["default"].createElement("fieldset", {
    className: ['ccl__edit-mode__element', 'ccl__form-input', 'ccl__form-input--is-checkbox-group', showError ? 'ccl__form-input--has-error' : ''].filter(function (val) {
      return val;
    }).join(' ')
  }, /*#__PURE__*/React__default["default"].createElement("span", {
    id: anchorId,
    className: "anchor"
  }), /*#__PURE__*/React__default["default"].createElement("legend", {
    className: "checkbox-list-question",
    id: field.valueField.id
  }, /*#__PURE__*/React__default["default"].createElement(Label, props)), showError ? /*#__PURE__*/React__default["default"].createElement("p", {
    className: "ccl__form-input__error-message ccl__text ccl__text--error-small-text"
  }, /*#__PURE__*/React__default["default"].createElement("span", {
    className: "ccl__icon ccl__icon--error ccl__icon--color--error ccl__icon--size--sm"
  }), errorArray[0]) : null, items.map(function (item, index) {
    return /*#__PURE__*/React__default["default"].createElement("div", {
      className: "ccl__field-control ccl__field-control--input-selectors",
      key: item.itemId
    }, /*#__PURE__*/React__default["default"].createElement("label", {
      className: "ccl__field-control__label ccl__field-control__label--is-checkbox ccl__text ccl__text--body-text"
    }, /*#__PURE__*/React__default["default"].createElement("span", {
      dangerouslySetInnerHTML: {
        __html: item.text
      }
    }), /*#__PURE__*/React__default["default"].createElement("input", {
      "aria-checked": value.some(function (v) {
        return v === item.value;
      }),
      "aria-describedby": errorMsgId,
      checked: value.some(function (v) {
        return v === item.value;
      }),
      className: "ccl__field-control__label__input ".concat(field.model.cssClass),
      id: field.valueField.id + index,
      name: field.model.name,
      onChange: handleChange,
      onFocus: function onFocus() {
        return sendFormInteraction(field.model.title);
      },
      type: "checkbox",
      value: item.value
    }), /*#__PURE__*/React__default["default"].createElement("div", {
      className: "ccl__field-control__indicator"
    })));
  }));
};

var CountrySelect = function CountrySelect(props) {
  var _useContext = React.useContext(FormContext),
      _useContext2 = _slicedToArray__default["default"](_useContext, 2),
      state = _useContext2[0],
      dispatch = _useContext2[1];

  var field = props.field,
      errors = props.errors,
      value = props.value,
      _onChange = props.onChange,
      siteObject = props.siteObject;
  var initialCountry = formatCountry(siteObject.country);
  var hidden = useVisibility(_onChange, field, value); // register initial value

  React.useEffect(function () {
    if (siteObject.country) {
      handleOnChange(field, initialCountry, _onChange, dispatch, state);
    }
  }, []);

  if (hidden) {
    return null;
  }

  var errorArray = checkValidations(errors, state.fieldState, field);
  var showError = errorArray && errorArray.length > 0;
  return /*#__PURE__*/React__default["default"].createElement("div", {
    className: "ccl__edit-mode__element"
  }, /*#__PURE__*/React__default["default"].createElement(foundation.CountrySelect, {
    defaultValue: initialCountry,
    error: showError,
    errorMsg: showError ? errorArray[0] : undefined,
    id: field.valueField.id,
    isSearchable: true,
    label: field.model.title,
    lng: formatLanguage(siteObject.lang),
    maxResults: 6,
    name: field.model.name,
    noOptionsMessage: field.model.noMatchesMessage,
    onBlur: function onBlur() {
      return handleOnBlur(field, props, dispatch);
    },
    onChange: function onChange(_name, _value) {
      return handleOnChange(field, _value, _onChange, dispatch, state);
    },
    onFocus: function onFocus() {
      return sendFormInteraction(field.model.title);
    },
    promptText: field.model.countryCodePlaceholderText,
    showISO: false,
    showResultsISO: false,
    visibleCountryOption: field.model.items.length > 0 ? field.model.items.map(function (_ref) {
      var value = _ref.value;
      return value;
    }) : undefined
  }));
};

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty__default["default"](target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var isLeapYear = function isLeapYear(year) {
  if (year % 4 === 0) {
    if (year % 100 === 0) {
      if (year % 400) {
        return true;
      }

      return false;
    }

    return true;
  }

  return false;
};

var MIN_YEAR = 1900;

var isValidDate = function isValidDate(day, month, year) {
  if (year < MIN_YEAR || month < 1 || month > 12) {
    return false;
  }

  var maxDay = month === 2 ? isLeapYear(year) ? 29 : 28 : [1, 3, 5, 7, 8, 10, 12].includes(month) ? 31 : 30;

  if (day < 1 || day > maxDay) {
    return false;
  }

  return true;
};

var DayMonthYear = function DayMonthYear(props) {
  var _useContext = React.useContext(FormContext),
      _useContext2 = _slicedToArray__default["default"](_useContext, 2),
      state = _useContext2[0],
      dispatch = _useContext2[1]; // form context to track validating the completed value
  // value is either '' or entire valid date string in 'yyyy-mm-dd' format


  var field = props.field,
      errors = props.errors,
      value = props.value,
      onChange = props.onChange; // internal state to track field values

  var _useState = React.useState(''),
      _useState2 = _slicedToArray__default["default"](_useState, 2),
      day = _useState2[0],
      setDay = _useState2[1];

  var _useState3 = React.useState(''),
      _useState4 = _slicedToArray__default["default"](_useState3, 2),
      month = _useState4[0],
      setMonth = _useState4[1];

  var _useState5 = React.useState(''),
      _useState6 = _slicedToArray__default["default"](_useState5, 2),
      year = _useState6[0],
      setYear = _useState6[1]; // whether all fields have been completed before - then always validate


  var _useState7 = React.useState(false),
      _useState8 = _slicedToArray__default["default"](_useState7, 2),
      hasCompletedFields = _useState8[0],
      setHasCompletedFields = _useState8[1];

  var hidden = useVisibility(onChange, field, value);

  if (hidden) {
    return null;
  }

  var errorArray = checkValidations(errors, state.fieldState, field);
  var showError = errorArray && errorArray.length > 0; // todo - can be dynamic based on country

  var fieldOrder = ['DD', 'MM', 'YYYY'];

  var handleChange = function handleChange(newDay, newMonth, newYear) {
    if (newDay && newMonth && newYear && isValidDate(Number(newDay), Number(newMonth), Number(newYear))) {
      setHasCompletedFields(true);
      handleOnChange(field, "".concat(newYear, "-").concat(newMonth.padStart(2, '0'), "-").concat(newDay.padStart(2, '0')), onChange, dispatch, state);
    } else {
      // report as invalid field if any values have not been filled or date is invalid
      handleOnChange(field, '', onChange, dispatch, state);
    }
  };

  var handleBlur = function handleBlur(fieldLabel) {
    // don't throw invalid message if user hasn't finished entering fields
    if (fieldOrder.indexOf(fieldLabel) < fieldOrder.length + 1 && !hasCompletedFields) {
      return;
    }

    handleOnBlur(field, props, dispatch);
  };

  var dayProps = {
    id: "".concat(field.valueField.id, "-day"),
    label: 'DD',
    maxLength: 2,
    name: "".concat(field.model.name, "-day"),
    size: 2,
    stateManaged: true,
    onBlur: function onBlur() {
      handleBlur('DD');

      if (day.length === 1 && day !== '0') {
        setDay(day.padStart(2, '0'));
      }
    },
    onChange: function onChange(evt) {
      setDay(evt.target.value);
      handleChange(evt.target.value, month, year);
    },
    value: day
  };
  var monthProps = {
    id: "".concat(field.valueField.id, "-month"),
    label: 'MM',
    maxLength: 2,
    name: "".concat(field.model.name, "-month"),
    size: 2,
    stateManaged: true,
    onBlur: function onBlur() {
      handleBlur('MM');

      if (month.length === 1 && month !== '0') {
        setMonth(month.padStart(2, '0'));
      }
    },
    onChange: function onChange(evt) {
      setMonth(evt.target.value);
      handleChange(day, evt.target.value, year);
    },
    value: month
  };
  var yearProps = {
    id: "".concat(field.valueField.id, "-year"),
    label: 'YYYY',
    maxLength: 4,
    name: "".concat(field.model.name, "-year"),
    size: 4,
    stateManaged: true,
    onBlur: function onBlur() {
      return handleBlur('YYYY');
    },
    onChange: function onChange(evt) {
      setYear(evt.target.value);
      handleChange(day, month, evt.target.value);
    },
    value: year
  };
  return /*#__PURE__*/React__default["default"].createElement("div", {
    className: "ccl__edit-mode__element"
  }, /*#__PURE__*/React__default["default"].createElement(foundation.DateInput, {
    error: showError,
    errorMsg: showError ? errorArray[0] : undefined,
    fields: fieldOrder.map(function (fieldLabel, idx) {
      return _objectSpread(_objectSpread({}, [dayProps, monthProps, yearProps].find(function (_ref) {
        var label = _ref.label;
        return label === fieldLabel;
      })), idx === 0 ? {
        onFocus: function onFocus() {
          return sendFormInteraction(field.model.title);
        }
      } : {});
    }),
    isStrict: true,
    label: field.model.title
  }));
};

var DropdownList = function DropdownList(props) {
  var _useContext = React.useContext(FormContext),
      _useContext2 = _slicedToArray__default["default"](_useContext, 2),
      state = _useContext2[0],
      dispatch = _useContext2[1];

  var field = props.field,
      value = props.value,
      _onChange = props.onChange,
      errors = props.errors;
  var initialValue = field.model.items.find(function (_ref) {
    var selected = _ref.selected;
    return selected;
  }); // push initial value

  React.useEffect(function () {
    if (initialValue) {
      handleOnChange(field, initialValue.value, _onChange, dispatch, state);
    }
  }, []);
  var hidden = useVisibility(_onChange, field, value);

  if (hidden) {
    return null;
  }

  var errorArray = checkValidations(errors, state.fieldState, field);
  var showError = errorArray && errorArray.length > 0;
  return /*#__PURE__*/React__default["default"].createElement("div", {
    className: "ccl__edit-mode__element"
  }, /*#__PURE__*/React__default["default"].createElement(foundation.SelectInput, {
    dataList: [].concat(_toConsumableArray__default["default"](field.model.showEmptyItem ? [{
      label: ' ',
      value: ''
    }] : []), _toConsumableArray__default["default"](field.model.items.map(function (_ref2) {
      var text = _ref2.text,
          value = _ref2.value;
      return {
        label: text,
        value: value
      };
    }))),
    defaultValue: initialValue === null || initialValue === void 0 ? void 0 : initialValue.value,
    error: showError,
    errorMsg: showError ? errorArray[0] : undefined,
    id: field.valueField.id,
    isSearchable: false,
    label: field.model.title,
    name: field.model.name // no onBlur - react-select blur and change are fired at the same time for touch events
    // so the value is not updated for the blur handler
    // hence force validating when changed
    ,
    onChange: function onChange(_name, _value) {
      return handleOnChange(field, _value, _onChange, dispatch, state, true);
    },
    onFocus: function onFocus() {
      return sendFormInteraction(field.model.title);
    }
  }));
};

var baseTextareaClass = 'ccl__textarea-field__input ccl__textarea-field__input_lg';

var MultipleLineText = function MultipleLineText(props) {
  var _React$useContext = React__default["default"].useContext(FormContext),
      _React$useContext2 = _slicedToArray__default["default"](_React$useContext, 2),
      state = _React$useContext2[0],
      dispatch = _React$useContext2[1];

  var field = props.field,
      invalid = props.invalid,
      errors = props.errors,
      value = props.value,
      _onChange = props.onChange;
  var errorMsgId = "".concat(field.valueField.id, "-error-msg");
  var anchorId = "anchor-".concat(field.valueField.id);
  var hidden = useVisibility(_onChange, field, value);

  if (hidden) {
    return null;
  }

  var errorArray = checkValidations(errors, state.fieldState, field);
  var showError = errorArray && errorArray.length > 0;
  return /*#__PURE__*/React__default["default"].createElement("div", {
    className: "ccl__edit-mode__element"
  }, /*#__PURE__*/React__default["default"].createElement("div", {
    className: ['ccl__form-input', 'ccl__form-input--is-form-input', showError ? 'ccl__form-input--has-error' : ''].filter(function (val) {
      return val;
    }).join(' ')
  }, /*#__PURE__*/React__default["default"].createElement("span", {
    id: anchorId,
    className: "anchor"
  }), /*#__PURE__*/React__default["default"].createElement(Label, _extends__default["default"]({}, props, {
    key: "".concat(props.field.model.itemId, "_label")
  })), /*#__PURE__*/React__default["default"].createElement("div", {
    className: "ccl__textarea-field"
  }, /*#__PURE__*/React__default["default"].createElement("textarea", {
    "aria-describedby": errorMsgId,
    "aria-invalid": invalid,
    "aria-required": field.model.required,
    className: [baseTextareaClass, field.model.cssClass, showError ? 'ccl__textarea-field__input_error' : ''].filter(function (val) {
      return val;
    }).join(' '),
    id: field.valueField.id,
    maxLength: field.model.maxLength,
    name: field.model.name,
    onBlur: function onBlur() {
      return handleOnBlur(field, props, dispatch);
    },
    onChange: function onChange(e) {
      return handleOnChange(field, e.target.value, _onChange, dispatch, state);
    },
    onFocus: function onFocus() {
      return sendFormInteraction(field.model.title);
    },
    placeholder: field.model.placeholderText,
    rows: field.model.rows,
    value: value
  })), showError ? /*#__PURE__*/React__default["default"].createElement("p", {
    className: "ccl__form-input__error-message ccl__text ccl__text--error-small-text"
  }, /*#__PURE__*/React__default["default"].createElement("span", {
    className: "ccl__icon ccl__icon--error ccl__icon--color--error ccl__icon--size--xs"
  }), errorArray[0]) : null));
};

var RadioButtonList = function RadioButtonList(props) {
  var _React$useContext = React__default["default"].useContext(FormContext),
      _React$useContext2 = _slicedToArray__default["default"](_React$useContext, 2),
      state = _React$useContext2[0],
      dispatch = _React$useContext2[1];

  var field = props.field,
      items = props.field.model.items,
      value = props.value,
      _onChange = props.onChange,
      errors = props.errors;
  var hidden = useVisibility(_onChange, field, value);

  if (hidden) {
    return null;
  }

  var errorArray = checkValidations(errors, state.fieldState, field);
  var showError = errorArray && errorArray.length > 0;
  return /*#__PURE__*/React__default["default"].createElement("fieldset", {
    className: ['ccl__edit-mode__element', 'ccl__form-input', 'ccl__form-input--is-radio-group', showError ? 'ccl__form-input--has-error' : ''].filter(function (val) {
      return val;
    }).join(' ')
  }, /*#__PURE__*/React__default["default"].createElement("legend", {
    className: "radio-question",
    id: field.valueField.id
  }, /*#__PURE__*/React__default["default"].createElement(Label, props)), showError ? /*#__PURE__*/React__default["default"].createElement("p", {
    className: "ccl__form-input__error-message ccl__text ccl__text--error-small-text"
  }, /*#__PURE__*/React__default["default"].createElement("span", {
    className: "ccl__icon ccl__icon--error ccl__icon--color--error ccl__icon--size--sm"
  }), errorArray[0]) : null, items.map(function (item, index) {
    return /*#__PURE__*/React__default["default"].createElement("div", {
      key: item.itemId,
      className: "ccl__field-control ccl__field-control--input-selectors"
    }, /*#__PURE__*/React__default["default"].createElement("label", {
      className: "ccl__field-control__label ccl__field-control__label--is-radio ccl__text ccl__text--body-text"
    }, item.text, /*#__PURE__*/React__default["default"].createElement("input", {
      type: "radio",
      className: "ccl__field-control__label__input ".concat(field.model.cssClass),
      id: field.valueField.id + index,
      name: field.model.name,
      value: item.value,
      checked: value.some(function (v) {
        return v === item.value;
      }),
      onChange: function onChange(e) {
        return handleOnChange(field, [e.target.value], _onChange, dispatch, state);
      },
      onFocus: function onFocus() {
        return sendFormInteraction(field.model.title);
      }
    }), /*#__PURE__*/React__default["default"].createElement("div", {
      className: "ccl__field-control__indicator"
    })));
  }));
};

var Telephone = function Telephone(props) {
  return /*#__PURE__*/React__default["default"].createElement(SingleLineText, _extends__default["default"]({}, props, {
    type: "tel"
  }));
};

var Section = function Section(_ref) {
  var field = _ref.field,
      fieldFactory = _ref.fieldFactory;
  return /*#__PURE__*/React__default["default"].createElement("fieldset", {
    className: "".concat(field.model.cssClass, " ccl-l-userTabs__content")
  }, field.fields.map(fieldFactory));
};

/*
Format for custom toggleable field names is ___<LinkedFieldName>___Variation (triple underscore)
Example: To create a custom toggleable label for a FirstName field we can create
<Text name={'___FirstName___Child'} />
<Text name={'___FirstName___You'} />
<SingleLineText name={'FirstName'}/>
Both <Text> components in this case will have the htmlFor attribute to the id SingleLineText component
*/

var TextField = function TextField(_ref) {
  var field = _ref.field,
      formComponent = _ref.formComponent;
  var Tag = field.model.htmlTag || 'label'; // don't pass onChange function for non-value fields

  var hidden = useVisibility(null, field, '');

  if (hidden || !formComponent.current) {
    return null;
  }

  if (field.model.htmlTag === 'label') {
    return /*#__PURE__*/React__default["default"].createElement(Label, {
      field: {
        model: {
          labelCssClass: "".concat(field.model.cssClass, " text-label"),
          title: field.model.text
        },
        valueField: {
          id: getLinkedFocusId(field, formComponent.current.props.form)
        }
      }
    });
  }

  return /*#__PURE__*/React__default["default"].createElement(Tag, {
    className: "".concat(field.model.cssClass, " text-tag"),
    dangerouslySetInnerHTML: {
      __html: field.model.text
    }
  });
};
/**
 * Required to link custom toggleable labels to existing fields
 * returns field.valueField.id
 * @param {object} field
 * @param {Form} form
 */


var getLinkedFocusId = function getLinkedFocusId(field, form) {
  var htmlFor;

  if (field.model.name.split('___').length > 0) {
    htmlFor = field.model.name.split('___')[1];
  }

  var fieldReducer = function fieldReducer(field, currentField) {
    // recursively find values in the form
    // recurse on "fields"
    if (currentField.fields) {
      return currentField.fields.reduce(fieldReducer, field);
    }

    if (currentField.model.name === htmlFor) {
      return currentField.valueField.id;
    }

    return field;
  };

  return form.fields.reduce(fieldReducer);
};

var DateField = function DateField(props) {
  var _React$useContext = React__default["default"].useContext(FormContext),
      _React$useContext2 = _slicedToArray__default["default"](_React$useContext, 2),
      state = _React$useContext2[0],
      dispatch = _React$useContext2[1];

  var field = props.field,
      invalid = props.invalid,
      errors = props.errors,
      value = props.value,
      _onChange = props.onChange;
  var errorMsgId = "".concat(field.valueField.id, "-error-msg");
  var anchorId = "anchor-".concat(field.valueField.id);
  var hidden = useVisibility(_onChange, field, value);

  if (hidden) {
    return null;
  } // this effectively merges field state errors array and submission state errors array.
  // ideally field state errors would dispatch field state to form context rather than local context.
  // ...todo


  var errorArray = checkValidations(errors, state.fieldState, field);
  return /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, /*#__PURE__*/React__default["default"].createElement("div", {
    className: "sl-item"
  }, /*#__PURE__*/React__default["default"].createElement("span", {
    id: anchorId,
    className: "anchor"
  }), /*#__PURE__*/React__default["default"].createElement("div", {
    className: "form-input ".concat(errorArray && errorArray.length > 0
    /* && touched*/
    ? 'is-error' : '')
  }, /*#__PURE__*/React__default["default"].createElement(Label, _extends__default["default"]({}, props, {
    key: "".concat(props.field.model.itemId, "_label")
  }), /*#__PURE__*/React__default["default"].createElement("input", {
    type: "date",
    className: field.model.cssClass,
    id: field.valueField.id,
    name: field.model.name,
    value: formatValue(value),
    min: formatValue(field.model.min),
    max: formatValue(field.model.max),
    placeholder: field.model.placeholderText,
    onChange: function onChange(e) {
      return handleOnChange(field, e.target.value, _onChange, dispatch, state);
    },
    onBlur: function onBlur() {
      return handleOnBlur(field, props, dispatch);
    },
    "aria-required": field.model.required,
    "aria-invalid": invalid,
    "aria-describedby": errorMsgId,
    key: field.valueField.id
  }), errorArray && errorArray.length > 0 && /*#__PURE__*/React__default["default"].createElement("span", {
    className: "error"
  }, errorArray[0])))));
};
/**
 * @param {string} [value]
 */


function formatValue(value) {
  // dates are serialized from the API as full date/times (i.e. 2019-01-11T00:00:00)
  // but the date input expects only the date. Since the format is predictably long,
  // we can just take a substring.
  if (!value || value.length < 10) {
    return value;
  }

  return value.substring(0, 10);
}

function mapFields(form) {
  var fieldValues = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var conditionFields = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  var conditions = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  form.fields.forEach(function (section) {
    if (section.fields) {
      mapFields(section, fieldValues, conditionFields, conditions);
    }

    buildConditions(section.model.conditionSettings.fieldConditions, conditionFields, conditions);
    fieldValues[section.model.conditionSettings.fieldKey] = section.model.value;
  });
  return {
    fieldValues: fieldValues,
    conditions: conditions,
    conditionFields: conditionFields
  };
}

function buildConditions(fieldConditions, conditionFields, conditions) {
  fieldConditions.forEach(function (fieldItem) {
    // if item is part of a condition
    fieldItem.conditions.forEach(function (conditionItem) {
      if (conditionFields.indexOf(conditionItem.fieldId) < 0) {
        conditionFields.push(conditionItem.fieldId);
      }
    }); // if item is part of an action

    fieldItem.actions.forEach(function (actionItem) {
      if (conditionFields.indexOf(actionItem.fieldId) < 0) {
        conditionFields.push(actionItem.fieldId);
      }
      // check if that action has been defined first - then either create it or add the condition to it

      if (typeof conditions[actionItem.fieldId] === 'undefined') {
        conditions[actionItem.fieldId] = [{
          matchTypeId: fieldItem.matchTypeId,
          conditions: fieldItem.conditions,
          actionTypeId: actionItem.actionTypeId
        }];
      } else {
        conditions[actionItem.fieldId].push({
          matchTypeId: fieldItem.matchTypeId,
          conditions: fieldItem.conditions,
          actionTypeId: actionItem.actionTypeId
        });
      }
    });
  });
}

// field type mapping to IDs under /sitecore/system/Settings/Forms/Field Types
var fieldTypes = {
  Button: '{7CE25CAB-EF3A-4F73-AB13-D33BDC1E4EE2}',
  Checkbox: '{4DA85E8A-3B48-4BC6-9565-8C1F5F36DD1B}',
  CheckboxList: '{D86A361A-D4FF-46B2-9E97-A37FC5B1FE1A}',
  CountrySelect: '{FAAF849C-176E-415A-A5F7-4AD4C86E5F6E}',
  DateField: '{38137D30-7B2A-47D5-BBD8-133252C01B28}',
  DayMonthYear: '{A9A93E3F-FBF6-4F57-94FC-86FA5C0A9FE5}',
  DropdownList: '{E0CFADEE-1AC0-471D-A820-2E70D1547B4B}',
  Email: '{04C39CAC-8976-4910-BE0D-879ED3368429}',
  FileUpload: '{7E9A0903-A52C-4843-BBE1-5B26BD162BED}',
  HiddenField: '{34BF2963-984D-49F9-ACB4-480197E1FD80}',
  ListBox: '{222A2121-D370-4C6F-80A3-03C930B718BF}',
  MultipleLineText: '{A296A1C1-0DA0-4493-A92E-B8191F43AEC6}',
  NumberField: '{5B153FC0-FC3F-474F-8CB8-233FB1BEF292}',
  Password: '{668A1C37-9D6B-483B-B7C1-340C92D04BA4}',
  PhoneWithCountryCode: '{D564141A-F63F-449A-ADED-E35F4B269895}',
  RadioButtonList: '{EDBD38A8-1AE9-42EC-8CCD-F5B0E2998B4F}',
  Section: '{447AA745-6D29-4B65-A5A3-8173AA8AF548}',
  SingleLineText: '{4EE89EA7-CEFE-4C8E-8532-467EF64591FC}',
  Telephone: '{DF74F55B-47E6-4D1C-92F8-B0D46A7B2704}',
  TextField: '{983BFA5F-C6B6-4AEE-A3BB-46B95D52E7DF}'
};

var withUpdateField = function withUpdateField(Component, props) {
  var _withUpdateField = function _withUpdateField(_props) {
    return /*#__PURE__*/React__default["default"].createElement(Component, _extends__default["default"]({}, _props, props, {
      key: "_".concat(_props.field.model.itemId)
    }));
  };

  return _withUpdateField;
};

var defaultFieldFactory = sitecoreJssReactForms.createDefaultFieldFactory();
defaultFieldFactory.setComponent(fieldTypes.Checkbox, Checkbox);
defaultFieldFactory.setComponent(fieldTypes.CheckboxList, CheckboxList);
defaultFieldFactory.setComponent(fieldTypes.DateField, DateField);
defaultFieldFactory.setComponent(fieldTypes.DropdownList, DropdownList);
defaultFieldFactory.setComponent(fieldTypes.Email, Email);
defaultFieldFactory.setComponent(fieldTypes.HiddenField, SingleLineText);
defaultFieldFactory.setComponent(fieldTypes.MultipleLineText, MultipleLineText);
defaultFieldFactory.setComponent(fieldTypes.RadioButtonList, RadioButtonList);
defaultFieldFactory.setComponent(fieldTypes.Section, Section);
defaultFieldFactory.setComponent(fieldTypes.SingleLineText, SingleLineText);
defaultFieldFactory.setComponent(fieldTypes.Telephone, Telephone);
defaultFieldFactory.setComponent(fieldTypes.TextField, TextField);

var CochlearForm = function CochlearForm(_ref) {
  var additionalFields = _ref.additionalFields,
      formData = _ref.formData,
      instanceParameters = _ref.instanceParameters,
      noMentorMessage = _ref.noMentorMessage,
      pushSubmitSuccess = _ref.onSubmitSuccess,
      _reCaptchaSiteKey = _ref.reCaptchaSiteKey,
      redirectLink = _ref.redirectLink,
      requireMentor = _ref.requireMentor,
      _ref$sitecoreApiHost = _ref.sitecoreApiHost,
      sitecoreApiHost = _ref$sitecoreApiHost === void 0 ? '' : _ref$sitecoreApiHost,
      _ref$sitecoreApiKey = _ref.sitecoreApiKey,
      sitecoreApiKey = _ref$sitecoreApiKey === void 0 ? '' : _ref$sitecoreApiKey,
      _ref$siteObject = _ref.siteObject,
      siteObject = _ref$siteObject === void 0 ? {
    country: '',
    lang: 'en'
  } : _ref$siteObject,
      SubmissionErrorMessage = _ref.SubmissionErrorMessage,
      SubmissionSuccessMessage = _ref.SubmissionSuccessMessage;
  var formComponent = React.useRef(null);

  var _useState = React.useState(function () {
    return mapFields(formData);
  }),
      _useState2 = _slicedToArray__default["default"](_useState, 1),
      formState = _useState2[0];

  var _useState3 = React.useState(null),
      _useState4 = _slicedToArray__default["default"](_useState3, 2),
      submissionState = _useState4[0],
      setSubmissionState = _useState4[1]; // null on ssr and first render


  var _useState5 = React.useState(null),
      _useState6 = _slicedToArray__default["default"](_useState5, 2),
      hasMentorCode = _useState6[0],
      setHasMentorCode = _useState6[1];

  var _useState7 = React.useState(function () {
    defaultFieldFactory.setComponent(fieldTypes.Button, withUpdateField(Button, {
      additionalFields: additionalFields,
      formComponent: formComponent,
      instanceParameters: instanceParameters,
      onSubmitResult: setSubmissionState,
      reCaptchaSiteKey: _reCaptchaSiteKey.value,
      redirectLink: redirectLink
    }));
    defaultFieldFactory.setComponent(fieldTypes.CountrySelect, withUpdateField(CountrySelect, {
      siteObject: siteObject
    }));
    defaultFieldFactory.setComponent(fieldTypes.DayMonthYear, withUpdateField(DayMonthYear, {
      siteObject: siteObject
    }));
    defaultFieldFactory.setComponent(fieldTypes.PhoneWithCountryCode, withUpdateField(PhoneWithCountryCode, {
      siteObject: siteObject
    }));
    defaultFieldFactory.setComponent(fieldTypes.TextField, withUpdateField(TextField, {
      formComponent: formComponent
    }));
    return defaultFieldFactory;
  }),
      _useState8 = _slicedToArray__default["default"](_useState7, 1),
      fieldFactory = _useState8[0]; // only read session storage on client


  React.useEffect(function () {
    if (requireMentor !== null && requireMentor !== void 0 && requireMentor.value && hasMentorCode === null) {
      setHasMentorCode(!!sessionStorage.getItem('volunteerMentorCode'));
    }
  }, [requireMentor === null || requireMentor === void 0 ? void 0 : requireMentor.value]);

  if (requireMentor !== null && requireMentor !== void 0 && requireMentor.value) {
    if (hasMentorCode === false) {
      return /*#__PURE__*/React__default["default"].createElement(FormSubmitted, _extends__default["default"]({}, noMentorMessage.fields, {
        pictogram: "Error"
      }));
    } // empty render on ssr


    if (hasMentorCode === null) {
      return null;
    }
  }

  if (submissionState === 'success') {
    if (pushSubmitSuccess) {
      pushSubmitSuccess();
      return null;
    }

    return /*#__PURE__*/React__default["default"].createElement(FormSubmitted, _extends__default["default"]({}, SubmissionSuccessMessage.fields, {
      pictogram: "EmailSent2"
    }));
  }

  if (submissionState === 'error') {
    return /*#__PURE__*/React__default["default"].createElement(FormSubmitted, _extends__default["default"]({}, SubmissionErrorMessage.fields, {
      pictogram: "Error"
    }));
  }

  return /*#__PURE__*/React__default["default"].createElement(FormProvider, {
    initialState: formState
  }, /*#__PURE__*/React__default["default"].createElement("div", {
    id: "sc-form"
  }, /*#__PURE__*/React__default["default"].createElement(sitecoreJssReactForms.Form, {
    fieldFactory: fieldFactory,
    form: formData,
    ref: formComponent,
    errorComponent: function errorComponent() {
      return null;
    },
    sitecoreApiHost: sitecoreApiHost,
    sitecoreApiKey: sitecoreApiKey
  })));
};

var FormSubmitted = function FormSubmitted(_ref2) {
  var description = _ref2.description,
      pictogram = _ref2.pictogram,
      title = _ref2.title;
  return /*#__PURE__*/React__default["default"].createElement("div", {
    className: "ccl__container thankyou-container"
  }, /*#__PURE__*/React__default["default"].createElement("div", {
    className: "ccl__columns"
  }, /*#__PURE__*/React__default["default"].createElement("div", {
    className: "ccl__column is-narrow"
  }, /*#__PURE__*/React__default["default"].createElement(foundation.Pictogram, {
    name: pictogram
  })), /*#__PURE__*/React__default["default"].createElement("div", {
    className: "ccl__column"
  }, /*#__PURE__*/React__default["default"].createElement("h2", {
    className: "ccl__title ccl__title--heading-2"
  }, title.value), /*#__PURE__*/React__default["default"].createElement("p", {
    dangerouslySetInnerHTML: {
      __html: description.value
    }
  }))));
};

module.exports = CochlearForm;
